export const state = {
  domaine: undefined,
  domaines: [],
  communes: [],
  sousDomaine: undefined,
  sousDomaines: [],
  pagination: { size: 10 },
};